<style lang="less" scoped>
.notification {
  background-color: @white;
  display: flex;
  border-radius: @border-radius-base;
  padding: 10px 30px;
  position: relative;
  .sort-list {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
  }
  .sort-list li {
    display: flex;
    font-size: 20px;
    text-align: left;
    padding: 20px 0;
    border-bottom: 1px solid #edeef1;
    cursor: pointer;
    .txt {
      margin-left: 10px;
    }
    .arrow {
      position: absolute;
      right: 50px;
    }
  }
  .sort-list li:last-child {
    border-bottom: none;
  }
  .sort-list li:hover {
    color: @primary-color;
  }
}
.loading {
  text-align: center;
  padding: 50px;
}
/deep/.ant-modal-content {
  background-color: #f1f0f0;
  border-radius: 10px;
}
.title {
  font-size: 24px;
  margin: 0px 30px 20px 30px;
}
.list {
  background-color: @white;
  border-radius: @border-radius-base;
  margin: 10px 30px;
  padding: 20px 30px;
  font-size: 20px;
  .biaoti {
    color: @primary-color;
  }
  .content {
    padding-top: 10px;
  }
  .date {
    margin-top: 10px;
    font-size: 14px;
    color: #bdb6b4;
  }
}
/deep/ .ant-modal-close-icon {
  color: @primary-color;
}
</style>

<template>
  <div class="notification">
    <!-- <ul class="sort-list">
      <li @click="getMessages(2)">
        <han-icon type="sysMsgIcon" /><span class="txt">专题及文章推送</span>
        <a-icon class="arrow" type="right" />
      </li>
      <li @click="getMessages(1)">
        <han-icon type="articleMsgIcon" /><span class="txt">系统消息</span>
        <a-icon class="arrow" type="right" />
      </li>
    </ul> -->
    <a-tabs default-active-key="2"
            class="sort-list"
            size="large"
            @change="callback">
      <a-tab-pane key="2"
                  tab="专题及文章推送">
        <!-- <div class="title">{{title}}</div> -->
        <div v-for="(item,index) in msgList"
             class="list"
             :key="index">
          <div class="biaoti">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
          <div class="date">{{ format.format(item.createDate) }}</div>
        </div>
        <div class="loading"
             v-show="loading">
          <a-spin />
        </div>
        <a-empty v-if="!msgList || msgList.length===0" />
      </a-tab-pane>
      <a-tab-pane key="1"
                  tab="系统消息">
        <!-- <div class="title">{{title}}</div> -->
        <div v-for="(item,index) in msgList"
             class="list"
             :key="index">
          <div class="biaoti">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
          <div class="date">{{ format.format(item.createDate) }}</div>
        </div>
        <div class="loading"
             v-show="loading">
          <a-spin />
        </div>
        <a-empty v-if="!msgList || msgList.length===0" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import format from '../../utils/format.js'
import HanIcon from 'components/Icon.vue'
export default {
  name: 'MyHistory',
  components: { HanIcon },
  data () {
    return {
      loading: false,
      msgList: [],
      format
    }
  },
  mounted () {
    this.getMessages(2)
  },
  methods: {
    callback (type) {
      this.getMessages(type)
    },
    getMessages (type) {
      // this.title = type === 2 ? '专题及文章推送' : '系统消息'
      this.$fetch({
        url: this.$baseUrl + 'ebook/personal/getMessageList',
        body: {
          type: type
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.msgList = res.resultData
        }
      })
    }
  }
}
</script>
